import '../../styles/restScreens.css';
import { useEffect, useState } from 'react';
import { supabaseClient } from '../../config/supabase';

export default function WhiteLabelEmailSetting({ theme = 'light' }) {
    const [settings, setSettings] = useState(null);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const dark = theme === 'dark';

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const { data, error: loadError } = await supabaseClient.rpc('bl400_email_settings');
                if (loadError || !data || typeof data.white_label_emails !== 'boolean') {
                    throw new Error('Could not load the email footer setting.');
                }
                if (!cancelled) setSettings(data);
            } catch {
                if (!cancelled) setError('Could not load the email footer setting.');
            }
        };
        load();
        return () => { cancelled = true; };
    }, []);

    const save = async (enabled) => {
        if (settings?.can_manage !== true || saving) return;
        setSaving(true);
        setError('');
        setMessage('');
        try {
            const { data, error: saveError } = await supabaseClient.rpc('bl400_set_white_label_emails', {
                p_org: settings.org_id, p_enabled: enabled,
            });
            if (saveError || !data || data.white_label_emails !== enabled) {
                throw new Error('Not saved. Only an Owner or platform Super Admin can change this.');
            }
            setSettings(data);
            setMessage('Saved. This applies to the next email sent.');
        } catch {
            setError('Not saved. Only an Owner or platform Super Admin can change this.');
        } finally {
            setSaving(false);
        }
    };

    if (!settings) return error
        ? <p role="alert" className="text-sm text-red-600">{error}</p>
        : <p className="text-sm">Loading email footer setting...</p>;

    return (
        <div data-m6-layout="entities" data-m6-component="WhiteLabelEmailSetting" className={`mt-5 space-y-2 text-sm ${dark ? 'text-gray-300' : 'text-gray-700'}`}>
            <label className="flex items-start gap-3">
                <input type="checkbox" checked={settings.white_label_emails}
                    disabled={settings.can_manage !== true || saving}
                    onChange={(event) => save(event.target.checked)} className="mt-1" />
                <span>White-label emails — hide 'via IntelAgent' in emails sent to your team</span>
            </label>
            {settings.can_manage !== true && <p className="text-xs">Only an Owner or platform Super Admin can change this.</p>}
            {message && <p role="status">{message}</p>}
            {error && <p role="alert" className="text-red-600">{error}</p>}
        </div>
    );
}
